export const greekCourts = [
   "ΠΡΩΤΟΔΙΚΕΙΟ ΑΘΗΝΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΘΗΝΩΝ",
  "ΕΦΕΤΕΙΟ ΑΘΗΝΩΝ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΠΕΙΡΑΙΑ",
  "ΑΡΕΙΟΣ ΠΑΓΟΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΓΡΙΝΙΟΥ",
    "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΙΓΙΑΛΕΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΛΕΞΑΝΔΡΕΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΛΜΥΡΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΛΜΩΠΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΜΑΡΟΥΣΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΜΥΝΤΑΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΜΦΙΣΣΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΝΔΡΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΡΓΟΥΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΡΝΑΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΡΤΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΤΑΛΑΝΤΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΑΧΑΡΝΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΒΑΛΤΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΒΑΜΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΒΑΣΙΛΙΚΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΒΕΡΟΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΒΟΛΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΓΙΑΝΝΙΤΣΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΓΡΕΒΕΝΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΓΥΘΕΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΔΙΔΥΜΟΤΕΙΧΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΕΔΕΣΣΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΕΛΑΣΣΟΝΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΕΛΕΥΣΙΝΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΕΠΙΔΑΥΡΟΥ (ΛΙΜΗΡΑΣ)",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΕΡΜΟΥΠΟΛΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΕΥΡΥΤΑΝΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΖΑΚΥΝΘΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΗΓΟΥΜΕΝΙΤΣΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΗΡΑΚΛΕΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΘΑΣΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΘΗΒΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΘΗΡΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΙΕΡΑΠΕΤΡΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΙΛΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΙΩΑΝΝΙΝΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΒΑΛΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΛΑΜΑΤΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΛΑΜΠΑΚΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΛΛΙΘΕΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΛΛΟΝΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΛΥΜΝΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΡΔΙΤΣΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΡΛΟΒΑΣΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΣΣΑΝΔΡΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΑΣΤΟΡΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΕΡΚΥΡΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΙΛΚΙΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΟΛΙΝΔΡΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΟΝΙΤΣΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΟΡΙΝΘΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΟΥΦΑΛΙΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΡΩΠΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΥΜΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΥΠΑΡΙΣΣΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΚΩ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΑΓΚΑΔΑ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΑΜΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΑΡΙΣΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΑΣΙΘΙΟΥ-ΝΕΑΠΟΛΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΑΥΡΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΕΡΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΗΜΝΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΛΙΒΑΔΕΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΑΡΑΘΩΝΟΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΑΣΣΗΤΟΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΕΓΑΡΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΕΣΟΛΟΓΓΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΗΛΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΟΙΡΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΟΥΔΑΝΙΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΥΚΟΝΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΜΥΤΙΛΗΝΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΝΑΟΥΣΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΝΑΥΠΑΚΤΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΝΑΥΠΛΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΝΕΑΠΟΛΕΩΣ-ΒΟΙΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΝΕΑΣ ΙΩΝΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΝΕΜΕΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΝΙΓΡΙΤΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΞΑΝΘΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΞΥΛΟΚΑΣΤΡΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΑΓΓΑΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΑΡΟΥ",
    "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΑΤΡΩΝ",

  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΕΙΡΑΙΑ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΕΡΙΣΤΕΡΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΙΕΡΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΛΩΜΑΡΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΟΛΥΓΥΡΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΟΛΥΚΑΣΤΡΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΡΕΒΕΖΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΠΥΛΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΡΟΔΟΛΙΒΟΥΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΡΟΔΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΑΜΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΕΡΡΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΗΤΕΙΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΙΚΥΩΝΟΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΙΝΤΙΚΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΚΟΠΕΛΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΚΥΔΡΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΣΠΑΡΤΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΤΗΝΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΤΡΙΚΑΛΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΤΡΙΠΟΛΗΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΦΑΡΣΑΛΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΦΛΩΡΙΝΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΧΑΛΑΝΔΡΙΟΥ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΧΑΛΚΙΔΑΣ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΧΑΝΙΩΝ",
  "ΕΙΡΗΝΟΔΙΚΕΙΟ ΧΙΟΥ",
  "ΕΦΕΤΕΙΟ ΑΙΓΑΙΟΥ",
  "ΕΦΕΤΕΙΟ ΑΝΑΤΟΛΙΚΗΣ ΚΡΗΤΗΣ",
  "ΕΦΕΤΕΙΟ ΒΟΡΕΙΟΥ ΑΙΓΑΙΟΥ",
  "ΕΦΕΤΕΙΟ ΔΥΤ.ΣΤΕΡΕΑΣ ΕΛΛΑΔΑΣ",
  "ΕΦΕΤΕΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ",
  "ΕΦΕΤΕΙΟ ΔΩΔΕΚΑΝΗΣΟΥ",
  "ΕΦΕΤΕΙΟ ΕΥΒΟΙΑΣ",
  "ΕΦΕΤΕΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ",
  "ΕΦΕΤΕΙΟ ΘΡΑΚΗΣ",
  "ΕΦΕΤΕΙΟ ΙΩΑΝΝΙΝΩΝ",
  "ΕΦΕΤΕΙΟ ΚΑΛΑΜΑΤΑΣ",
  "ΕΦΕΤΕΙΟ ΚΕΡΚΥΡΑΣ",
  "ΕΦΕΤΕΙΟ ΚΡΗΤΗΣ",
  "ΕΦΕΤΕΙΟ ΛΑΜΙΑΣ",
  "ΕΦΕΤΕΙΟ ΛΑΡΙΣΑΣ",
  "ΕΦΕΤΕΙΟ ΝΑΥΠΛΙΟΥ",
    "ΕΦΕΤΕΙΟ ΠΑΤΡΩΝ",

  "ΕΦΕΤΕΙΟ ΠΕΙΡΑΙΩΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ (ΑΓΡΙΝ.& ΜΕΣΟΛ.)",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΑΛΕΞΑΝΔΡΟΥΠΟΛΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΑΜΦΙΣΣΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΑΡΤΑΣ",
    "ΠΡΩΤΟΔΙΚΕΙΟ ΑΧΑΪΑΣ (ΠΑΤΡΩΝ & ΑΙΓΙΟΥ & ΚΑΛΑΒΡ.)",

  "ΠΡΩΤΟΔΙΚΕΙΟ ΒΕΡΟΙΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΒΟΙΩΤΙΑΣ (ΛΙΒΑΔ. & ΘΗΒΩΝ)",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΒΟΛΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΓΙΑΝΝΙΤΣΩΝ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΓΡΕΒΕΝΩΝ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΔΡΑΜΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΕΔΕΣΣΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΕΥΡΥΤΑΝΙΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΗΡΑΚΛΕΙΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΘΕΣΠΡΩΤΙΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΙΩΑΝΝΙΝΩΝ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΑΒΑΛΑΣ",
    "ΠΡΩΤΟΔΙΚΕΙΟ ΚΑΛΑΒΡΥΤΩΝ (ΚΑΤΑΡΓΗΘΗΚΕ)",

  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΑΡΔΙΤΣΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΑΣΤΟΡΙΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΑΤΕΡΙΝΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΕΡΚΥΡΑΣ",
    "ΠΡΩΤΟΔΙΚΕΙΟ ΚΕΦΑΛΛΗΝΙΑΣ",

  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΙΛΚΙΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΟΖΑΝΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΟΡΙΝΘΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΚΩ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΛΑΚΩΝΙΑΣ  (ΣΠΑΡΤΗΣ & ΓΥΘΕΙΟΥ)",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΛΑΚΩΝΙΑΣ (ΣΠΑΡΤΗΣ & ΓΥΘΕΙΟΥ)",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΛΑΜΙΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΛΑΡΙΣΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΛΑΣΙΘΙΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΛΕΥΚΑΔΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΜΕΣΟΛΟΓΓΙΟΥ (ΚΑΤΑΡΓΗΘΗΚΕ)",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΜΕΣΣΗΝΙΑΣ (ΚΑΛΑΜ. & ΚΥΠΑΡ.)",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΜΥΤΙΛΗΝΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΝΑΞΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΝΑΥΠΛΙΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΞΑΝΘΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΟΡΕΣΤΙΑΔΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΠΡΕΒΕΖΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΡΕΘΥΜΝΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΡΟΔΟΠΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΡΟΔΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΣΑΜΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΣΕΡΡΩΝ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΣΥΡΟΥ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΤΡΙΚΑΛΩΝ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΤΡΙΠΟΛΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΦΛΩΡΙΝΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΧΑΛΚΙΔΑΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΧΑΛΚΙΔΙΚΗΣ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΧΑΝΙΩΝ",
  "ΠΡΩΤΟΔΙΚΕΙΟ ΧΙΟΥ",
];
